import { CIcon } from '~/icons/types'

export const ciMotorhomes: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M2.936 12.341h4.127a.5.5 0 0 0 .5-.5V8.656a.5.5 0 0 0-.5-.5H2.936a.5.5 0 0 0-.5.5v3.185a.5.5 0 0 0 .5.5Zm.5-3.185h3.127v2.185H3.436V9.156Z'
    },
    {
      d:
        'M23.474 14.868a4.735 4.735 0 0 0-.514-2.1l-2.1-3.647a2.144 2.144 0 0 0-.282-.335l1.032-1.363a1.689 1.689 0 0 0-1.347-2.708H1a.5.5 0 0 0-.5.5v12.324a.5.5 0 0 0 .5.5h2.418A2.074 2.074 0 0 0 5 19.254a2.12 2.12 0 0 0 1.271-.174c.397-.185.727-.487.946-.866.032-.055.042-.118.069-.175H14.7a.5.5 0 0 0 .5-.491l.005-.24h.813a2.14 2.14 0 0 0 4.267 0H23a.498.498 0 0 0 .5-.506l-.026-1.934Zm-2.031-2.733h-3.378a1.122 1.122 0 0 1-.116 0V10.7h2.666l.828 1.435Zm-1.18-6.42a.689.689 0 0 1 .549 1.105l-1.094 1.445a2.1 2.1 0 0 0-.619-.1H14.7a.5.5 0 0 0-.5.5l.009 4.616h-1.116V8.657a.5.5 0 0 0-.5-.5H9.052a.5.5 0 0 0-.5.5v4.62H1.5V5.716h18.763ZM9.552 9.157h2.541v7.882H9.552V9.157Zm-3.2 8.554a1.151 1.151 0 1 1-1-1.73h.058c.28.017.543.133.744.328.2.194.324.455.347.733a1.13 1.13 0 0 1-.153.669h.004Zm1.15-.75a2.16 2.16 0 0 0-2.033-1.977 2.108 2.108 0 0 0-1.242.317c-.372.23-.666.569-.841.97a2.121 2.121 0 0 0-.162.768H1.5v-2.761h7.052v2.76H7.493c0-.025.007-.05 0-.074l.009-.002Zm5.6.078v-2.761h1.118v2.427l-.006.334h-1.112Zm5.058 1.245a1.152 1.152 0 1 1 .803-.339 1.153 1.153 0 0 1-.812.339h.009Zm1.987-1.975a2.15 2.15 0 0 0-3.973 0h-.95L15.2 9.16h3.9a1.095 1.095 0 0 1 .909.479l.032.056h-1.606c-.958 0-1.486 0-1.486.968v1.5c0 .362.145.968 1.116.968h3.954l.087.152c.237.498.363 1.041.368 1.593l.019 1.429-2.346.003Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'motorhomes',
  type: 'thin'
}
